module.exports = __webpack_public_path__ + "static/usatoday-480x480-e81e1ec8607d8274ef1c2148d0e2fd62.png";